import React from "react";

import styles from "./ErrorMessage.module.scss";

const ErrorMessage = ({ text, message }) => {
  return (
    <div className={styles.Main}>
      <div>
        <p>{text}</p>

        {message && <p>{`Описание ошибки: ${message}`}</p>}
      </div>
    </div>
  );
};

export default ErrorMessage;
